import { __exports as build } from './_virtual-index2.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireAsLowAsPricePerPiece } from './vp-tokenized-fragment-build-PricePresentations-components-AsLowAsPricePerPiece.js';
import { __require as requireLabeledPrice } from './vp-tokenized-fragment-build-PricePresentations-components-LabeledPrice.js';
import { __require as requirePriceForQtyUnits } from './vp-tokenized-fragment-build-PricePresentations-components-PriceForQtyUnits.js';
import { __require as requireQtyForOnly } from './vp-tokenized-fragment-build-PricePresentations-components-QtyForOnly.js';
import { __require as requireQtyStartingAtPrice } from './vp-tokenized-fragment-build-PricePresentations-components-QtyStartingAtPrice.js';
import { __require as requirePlusOrMinus } from './vp-tokenized-fragment-build-PricePresentations-components-PlusOrMinus.js';
import { __require as requirePlusOrMinusPerUnit } from './vp-tokenized-fragment-build-PricePresentations-components-PlusOrMinusPerUnit.js';
import { __require as requirePercentOff } from './vp-tokenized-fragment-build-PricePresentations-components-PercentOff.js';
import { __require as requireYouSaved } from './vp-tokenized-fragment-build-PricePresentations-components-YouSaved.js';
import { __require as requireRawPrice } from './vp-tokenized-fragment-build-PricePresentations-components-RawPrice.js';
import { __require as requirePricePerUnit } from './vp-tokenized-fragment-build-PricePresentations-components-PricePerUnit.js';
import { __require as requirePricePerPackage } from './vp-tokenized-fragment-build-PricePresentations-components-PricePerPackage.js';
import { __require as requirePricePerRecipient } from './vp-tokenized-fragment-build-PricePresentations-components-PricePerRecipient.js';
import { __require as requireCouponCallout } from './vp-tokenized-fragment-build-PricePresentations-components-CouponCallout.js';
import { __require as requireVatMessage } from './vp-tokenized-fragment-build-PricePresentations-components-VatMessage.js';
import { __require as requireVpTokenizedFragment } from './vp-tokenized-fragment-build-VpTokenizedFragment.js';
import { __require as requireTokenReplace } from './vp-tokenized-fragment-build-TokenReplace.js';
import { __require as requirePricePresentation } from './vp-tokenized-fragment-build-PricePresentations-PricePresentation.js';
import { __require as requireQtyForPrice } from './vp-tokenized-fragment-build-PricePresentations-components-QtyForPrice.js';
import { __require as requireQtyFromPrice } from './vp-tokenized-fragment-build-PricePresentations-components-QtyFromPrice.js';
import { __require as requireRangePrice } from './vp-tokenized-fragment-build-PricePresentations-components-RangePrice.js';
import { __require as requireBuild$1 } from './vp-js-token-engine-build-index.js';

var hasRequiredBuild;

function requireBuild () {
	if (hasRequiredBuild) return build;
	hasRequiredBuild = 1;
	(function (exports) {

		var _interopRequireDefault = requireInteropRequireDefault();
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		Object.defineProperty(exports, "AsLowAsPricePerPiece", {
		  enumerable: true,
		  get: function () {
		    return _AsLowAsPricePerPiece.default;
		  }
		});
		Object.defineProperty(exports, "ComparativeDisplayType", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.ComparativeDisplayType;
		  }
		});
		Object.defineProperty(exports, "CouponCallout", {
		  enumerable: true,
		  get: function () {
		    return _CouponCallout.default;
		  }
		});
		Object.defineProperty(exports, "ICouponCallout", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.ICouponCallout;
		  }
		});
		Object.defineProperty(exports, "IPercentage", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.IPercentage;
		  }
		});
		Object.defineProperty(exports, "IPlusOrMinus", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.IPlusOrMinus;
		  }
		});
		Object.defineProperty(exports, "IPrice", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.IPrice;
		  }
		});
		Object.defineProperty(exports, "IQuantityPrice", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.IQuantityPrice;
		  }
		});
		Object.defineProperty(exports, "IRangePrice", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.IRangePrice;
		  }
		});
		Object.defineProperty(exports, "ISavings", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.ISavings;
		  }
		});
		Object.defineProperty(exports, "IUnitPrice", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.IUnitPrice;
		  }
		});
		Object.defineProperty(exports, "IVatMessage", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.IVatMessage;
		  }
		});
		Object.defineProperty(exports, "LabeledPrice", {
		  enumerable: true,
		  get: function () {
		    return _LabeledPrice.default;
		  }
		});
		Object.defineProperty(exports, "PercentOff", {
		  enumerable: true,
		  get: function () {
		    return _PercentOff.default;
		  }
		});
		Object.defineProperty(exports, "PlusOrMinus", {
		  enumerable: true,
		  get: function () {
		    return _PlusOrMinus.default;
		  }
		});
		Object.defineProperty(exports, "PlusOrMinusPerUnit", {
		  enumerable: true,
		  get: function () {
		    return _PlusOrMinusPerUnit.default;
		  }
		});
		Object.defineProperty(exports, "PriceForQtyUnits", {
		  enumerable: true,
		  get: function () {
		    return _PriceForQtyUnits.default;
		  }
		});
		Object.defineProperty(exports, "PricePerPackage", {
		  enumerable: true,
		  get: function () {
		    return _PricePerPackage.default;
		  }
		});
		Object.defineProperty(exports, "PricePerRecipient", {
		  enumerable: true,
		  get: function () {
		    return _PricePerRecipient.default;
		  }
		});
		Object.defineProperty(exports, "PricePerUnit", {
		  enumerable: true,
		  get: function () {
		    return _PricePerUnit.default;
		  }
		});
		Object.defineProperty(exports, "PricePresentation", {
		  enumerable: true,
		  get: function () {
		    return _PricePresentation.default;
		  }
		});
		Object.defineProperty(exports, "QtyForOnly", {
		  enumerable: true,
		  get: function () {
		    return _QtyForOnly.default;
		  }
		});
		Object.defineProperty(exports, "QtyForPrice", {
		  enumerable: true,
		  get: function () {
		    return _QtyForPrice.default;
		  }
		});
		Object.defineProperty(exports, "QtyFromPrice", {
		  enumerable: true,
		  get: function () {
		    return _QtyFromPrice.default;
		  }
		});
		Object.defineProperty(exports, "QtyStartingAtPrice", {
		  enumerable: true,
		  get: function () {
		    return _QtyStartingAtPrice.default;
		  }
		});
		Object.defineProperty(exports, "RangePrice", {
		  enumerable: true,
		  get: function () {
		    return _RangePrice.default;
		  }
		});
		Object.defineProperty(exports, "RawPrice", {
		  enumerable: true,
		  get: function () {
		    return _RawPrice.default;
		  }
		});
		Object.defineProperty(exports, "TokenReplace", {
		  enumerable: true,
		  get: function () {
		    return _TokenReplace.default;
		  }
		});
		Object.defineProperty(exports, "VatMessage", {
		  enumerable: true,
		  get: function () {
		    return _VatMessage.default;
		  }
		});
		Object.defineProperty(exports, "VpTokenizedFragment", {
		  enumerable: true,
		  get: function () {
		    return _VpTokenizedFragment.default;
		  }
		});
		Object.defineProperty(exports, "YouSaved", {
		  enumerable: true,
		  get: function () {
		    return _YouSaved.default;
		  }
		});
		Object.defineProperty(exports, "ZeroDisplayType", {
		  enumerable: true,
		  get: function () {
		    return _vpJsTokenEngine.ZeroDisplayType;
		  }
		});
		var _AsLowAsPricePerPiece = _interopRequireDefault(requireAsLowAsPricePerPiece());
		var _LabeledPrice = _interopRequireDefault(requireLabeledPrice());
		var _PriceForQtyUnits = _interopRequireDefault(requirePriceForQtyUnits());
		var _QtyForOnly = _interopRequireDefault(requireQtyForOnly());
		var _QtyStartingAtPrice = _interopRequireDefault(requireQtyStartingAtPrice());
		var _PlusOrMinus = _interopRequireDefault(requirePlusOrMinus());
		var _PlusOrMinusPerUnit = _interopRequireDefault(requirePlusOrMinusPerUnit());
		var _PercentOff = _interopRequireDefault(requirePercentOff());
		var _YouSaved = _interopRequireDefault(requireYouSaved());
		var _RawPrice = _interopRequireDefault(requireRawPrice());
		var _PricePerUnit = _interopRequireDefault(requirePricePerUnit());
		var _PricePerPackage = _interopRequireDefault(requirePricePerPackage());
		var _PricePerRecipient = _interopRequireDefault(requirePricePerRecipient());
		var _CouponCallout = _interopRequireDefault(requireCouponCallout());
		var _VatMessage = _interopRequireDefault(requireVatMessage());
		var _VpTokenizedFragment = _interopRequireDefault(requireVpTokenizedFragment());
		var _TokenReplace = _interopRequireDefault(requireTokenReplace());
		var _PricePresentation = _interopRequireDefault(requirePricePresentation());
		var _QtyForPrice = _interopRequireDefault(requireQtyForPrice());
		var _QtyFromPrice = _interopRequireDefault(requireQtyFromPrice());
		var _RangePrice = _interopRequireDefault(requireRangePrice());
		var _vpJsTokenEngine = requireBuild$1();
		
	} (build));
	return build;
}

export { requireBuild as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-index.js.map
